// extracted by mini-css-extract-plugin
export default {"root":"_8-i00","left":"_3en2F","left-side-item-wrapper":"_3Xqgj","leftSideItemWrapper":"_3Xqgj","right":"_3EFo5","right-side-item-wrapper":"_1qUYL","rightSideItemWrapper":"_1qUYL"};